// Public browser configuration. Never put a service-role key here.
export const supabaseUrl = (
  import.meta.env.VITE_PUBLIC_SUPABASE_URL?.trim() ||
  'https://dzbtekawbeyhmwlwdpaj.supabase.co'
).replace(/\/+$/, '');

export const supabaseAnonKey =
  import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY?.trim() ||
  'sb_publishable_v5mOKgOal7Xz7fpSVsOYzQ_VBBDUPHz';

export const functionsBaseUrl = `${supabaseUrl}/functions/v1`;
